import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HostListenersCrumb(props: Partial<BreadcrumbData>) {
  return <Breadcrumb name="Listeners" {...props} />;
}
